import { IModel, Model } from ".";

export interface IPGRBreedModel extends IModel {
    pgrBreedId: number;
    type: string;
    code: string;
    sort: string;
    species: string;
    defaultPetpassBreedId?: number;
}

export class PGRBreedModel extends Model implements IPGRBreedModel {
    pgrBreedId: number;
    type: string;
    code: string;
    sort: string;
    species: string;
    defaultPetpassBreedId?: number | undefined;

    constructor(params: Partial<IPGRBreedModel> = {} as IPGRBreedModel) {
        super(params);
        const {
            pgrBreedId = 0,
            type = '',
            code = '',
            sort = '',
            species = '',
            defaultPetpassBreedId = undefined
        } = params;

        this.pgrBreedId = pgrBreedId;
        this.type = type;
        this.code = code;
        this.sort = sort;
        this.species = species;
        this.defaultPetpassBreedId = defaultPetpassBreedId;
    }
}
